import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {Row, Col, Card} from 'antd';

import * as actions from '../redux/actions/index';
import NationalMap from "../charts/NationalMap/index";
import ScatterPlot from "../charts/ScatterPlot/index";

import './NationalCard.css';

class NationalCard extends Component {
  render() {
    const selectState = stateId => {
      this.props.actions.selectState(stateId);
      this.props.actions.selectPage('state');
    };

    return (
      <Card className="NationalCard" noHovering={true} loading={this.props.loading}>
        <Row gutter={0}>
          <Col xs={24} md={12}>
            <h2 className="subtitle">
              <svg width={14} height={8}><rect width={8} height={8} rx={4} ry={4} fill="#e04040"></rect></svg>
              {this.props.xLabel} by State - {this.props.year}
              </h2>
            <NationalMap
              type="x"
              showLabels={true}
              titleX={this.props.xLabel}
              titleY={this.props.yLabel}
              dimX={this.props.xField}
              dimY={this.props.yField}
              dict={this.props.dict}
              data={this.props.data}
              year={this.props.year}
              onClick={selectState}/>
            <ScatterPlot
              type="x"
              dimId={this.props.idField}
              dimX={this.props.xField}
              dimY={this.props.yField}
              titleX={this.props.xLabel}
              titleY={this.props.yLabel}
              year={this.props.year}
              data={this.props.data}
              onClick={selectState}/>
          </Col>
          <Col xs={24} md={12}>
            <h2 className="subtitle">
              <svg width={14} height={8}><rect width={8} height={8} rx={4} ry={4} fill="#0f8ee9"></rect></svg>
              {this.props.yLabel} by State - {this.props.year}</h2>
            <NationalMap
              type="y"
              showLabels={true}
              titleX={this.props.xLabel}
              titleY={this.props.yLabel}
              dimX={this.props.xField}
              dimY={this.props.yField}
              dict={this.props.dict}
              data={this.props.data}
              year={this.props.year}
              onClick={selectState}/>
            <ScatterPlot
              type="y"
              dimId={this.props.idField}
              dimX={this.props.xField}
              dimY={this.props.yField}
              titleX={this.props.xLabel}
              titleY={this.props.yLabel}
              year={this.props.year}
              data={this.props.data}
              onClick={selectState}/>
          </Col>
        </Row>
      </Card>
    );
  }
}

function mapStoreToProps(store, props) {
  return {
    loading: store.states.loading || store.dimensions.loading,
    data: store.states.data,
    dict: store.states.dict,
    idField: store.dimensions.stateKey,
    xField: store.dimensions.xField,
    yField: store.dimensions.yField,
    xLabel: store.dimensions.xLabel,
    yLabel: store.dimensions.yLabel,
    xDesc: store.dimensions.xDesc,
    yDesc: store.dimensions.yDesc,
    year: store.dimensions.year
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  }
}

export default connect(mapStoreToProps, mapDispatchToProps)(NationalCard);



// WEBPACK FOOTER //
// ./src/containers/NationalCard.js